export default __webpack_public_path__ + "b581f72bc39f0717cdce75f5e12d34ad.jpg";